import { Box, Typography } from "@mui/material";

import { PrinterIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import { DynamicButton } from "components/DynamicButton/DynamicButton";

type HeaderProps = {
  title: string;
};

export function Header({ title }: HeaderProps) {
  const { t } = useTranslation();

  return (
    <Box
      display={"flex"}
      justifyContent={"space-between"}
      alignItems={"center"}
      padding={1.5}
    >
      <Typography variant={"headingXLargeSemibold"}>{title}</Typography>
      <DynamicButton
        startIcon={<PrinterIcon />}
        color={"info"}
        onClick={() => globalThis.print()}
        sx={{ displayPrint: "none" }}
      >
        {t("Export PDF")}
      </DynamicButton>
    </Box>
  );
}
